import { useContext } from "react";
import { LANGUAGE_PARAMS } from "../../components/shared/components/LanguageSelector/constants/LanguageParams";
import { LANGUAGES } from "../../config/languages";
import { ConfigContext } from "../../contexts/ConfigContext";

export const LANGUAGE_COOKIE_NAME = "language";

export const useLanguages = () => {
  const { dispatch: configDispatch } = useContext(ConfigContext);

  const setLanguageInApp = (language) => {
    localStorage.setItem(LANGUAGE_COOKIE_NAME, language);
    configDispatch({
      type: "SET_LANGUAGE",
      payload: language,
    });
  };

  const getRegionByLanguage = (language) => {
    if (!isLanguageSupported(language))
      return LANGUAGE_PARAMS[LANGUAGES.spanish].region;
    return LANGUAGE_PARAMS[language].region;
  };

  const setLanguageAndRegionInContext = (language, region) => {
    if (!region) getRegionByLanguage(language);
    try {
      configDispatch({
        type: "SET_REGION",
        payload: region,
      });
      setLanguageInApp(language);
    } catch (error) {
      configDispatch({
        type: "SET_LANGUAGE",
        payload: LANGUAGES.spanish,
      });
    }
  };

  const setLanguage = () => {
    try {
      setLanguageByUrlParam();
    } catch (err) {
      try {
        setLanguageByCookie();
      } catch (err) {
        setDefaultLanguageAndRegion();
      }
    }
  };

  const setLanguageByUrlParam = () => {
    const queryParams = new URLSearchParams(location.search);
    const localeParam = queryParams.get("locale");
    if (!localeParam) throw new Error("LocaleParamNotDefinedError");
    const locale = new Intl.Locale(localeParam.replace("_", "-"));
    const language = locale.language;
    const region = locale.region;
    if (!isLanguageSupported(language)) throw new Error("LanguageNotSupported");
    setLanguageAndRegionInContext(language, region);
  };

  const setLanguageByCookie = () => {
    const language = localStorage.getItem(LANGUAGE_COOKIE_NAME);
    if (!language) throw new Error("LanguageCookieNotDefined");
    if (!isLanguageSupported(language)) throw new Error("LanguageNotSupported");
    const region = getRegionByLanguage(language);
    setLanguageAndRegionInContext(language, region);
  };

  const setDefaultLanguageAndRegion = () => {
    const language = LANGUAGES.spanish;
    const region = LANGUAGE_PARAMS[LANGUAGES.spanish].region;
    setLanguageAndRegionInContext(language, region);
  };

  return { setLanguage, setLanguageInApp };
};

const isLanguageSupported = (language) =>
  Object.values(LANGUAGES).some(
    (allowedLanguage) => allowedLanguage === language
  );
